import { Badge } from '@/components/ui/badge';

interface AssigneeCellProps {
  displayName: string | null | undefined;
  email: string | null | undefined;
  isPending?: boolean;
}

export function AssigneeCell({ displayName, email, isPending }: AssigneeCellProps) {
  if (!displayName && !email) return <span className="text-text-secondary text-xs">—</span>;
  if (isPending || !displayName) {
    return (
      <div className="flex items-center gap-1.5">
        <span className="text-xs text-text-primary">{email}</span>
        {isPending && <Badge variant="amber" className="text-[9px] py-0">Pending</Badge>}
      </div>
    );
  }
  return (
    <div>
      <p className="text-xs text-text-primary">{displayName}</p>
      {email && <p className="text-[10px] text-text-secondary">{email}</p>}
    </div>
  );
}
